import { Stack, Typography, Button } from '@mui/material'
import { useState } from 'react'
import DialogDetalheDadosCadastrais from './DialogDetalheDadosCadastrais'

export default function InfoDadosCadastrais({
    resposta
}: InfoDadosCadastraisProps) {
    const [dialogOpen, setDialogOpen] = useState(false)



    const isCNPJ = (documento: string | undefined) => {
        if (!documento) return false;
        const cleaned = documento.replace(/\D/g, '');
        return cleaned.length === 14;
    }

    return (
        <>
            <Stack direction={'column'} spacing={1} mt={2}>
                <Stack direction={'row'} spacing={2}>
                    <Typography variant='caption'><b>Nome:</b> {resposta?.nome_publico}</Typography>
                    <Typography variant='caption'><b>{isCNPJ(resposta?.documento) ? 'CNPJ' : 'CPF'}:</b> {resposta?.documento}</Typography>
                </Stack>
                {
                    resposta?.possui_conjuge && resposta?.possui_conjuge === 'Sim' &&
                    <Stack direction={'row'} spacing={2}>
                        <Typography variant='caption'><b>Cônjuge:</b> {resposta?.possui_conjuge === 'Sim' ? resposta?.nome_conjuge : '-'}</Typography>
                        <Typography variant='caption'><b>CPF Cônjuge:</b> {resposta?.possui_conjuge === 'Sim' ? resposta?.cpf_conjuge : '-'}</Typography>
                    </Stack>
                }
                <Stack direction={'row'} spacing={2}>
                    <Typography variant='caption'><b>CEP:</b> {resposta?.cep}</Typography>
                    <Typography variant='caption'><b>Endereço:</b> {resposta?.endereco} {resposta.numero ?? 'S/N'} {resposta.complemento}</Typography>
                    <Typography variant='caption'><b>Cidade:</b> {resposta?.cidade}/{resposta?.uf}</Typography>
                </Stack>
                <Stack direction={'row'} spacing={2}>
                    {resposta?.sociedades && resposta.sociedades.length > 0 && (
                        <Typography variant='caption'><b>Sócios:</b> {resposta.sociedades.length}</Typography>
                    )}
                    {resposta?.procuradores && resposta.procuradores.length > 0 && (
                        <Typography variant='caption'><b>Procuradores:</b> {resposta.procuradores.length}</Typography>
                    )}
                    {resposta?.terceiros && resposta.terceiros.length > 0 && (
                        <Typography variant='caption'><b>Terceiros Autorizados:</b> {resposta.terceiros.length}</Typography>
                    )}
                </Stack>
                <Stack direction={'column'} spacing={2} alignItems={'start'}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setDialogOpen(true)}
                    >
                        Ver Detalhes
                    </Button>
                </Stack>
            </Stack>

            <DialogDetalheDadosCadastrais
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                dados={resposta}
            />
        </>
    )
}

interface Convenio {
    codigo: string
    nome: string
}

interface Fazenda {
    nome: string
    cnpj: string
    natureza_propriedade: string
    incra: string
    nirf: string
    arrendatario: string
    tamanho: string
    funrural: string
    senar: string
    rat: string
    tributa_icms: string
    cidade: string
    uf: string
    cep: string
    inscricao_fazenda: string
    produtor_leite: string
    produtor_cafe: string
    produtor_milho: string
    vencimento_inscricao: string
    icms_aliquota: string
    icms_percentual: string
    trib_entrada_leite: string
    vencimento_contrato: string
}

interface Sociedade {
    tipo_socio: string
    nome: string
    nome_social: string
    rg: string
    cpf: string
    sexo: string
    data_nascimento: string
    nacionalidade: string
    cnpj?: string
    nome_mae?: string
    nome_pai?: string
    grau_parentesco?: string
    possui_conjuge?: string
    telefone?: string
    cep?: string
    endereco?: string
    numero?: string
    complemento?: string
    bairro?: string
    uf?: string
    cidade?: string
    nome_conjuge?: string
    nome_social_conjuge?: string
    rg_conjuge?: string
    cpf_conjuge?: string
    sexo_conjuge?: string
    nome_mae_conjuge?: string
    nome_pai_conjuge?: string
    data_nascimento_conjuge?: string
    nacionalidade_conjuge?: string
    cep_conjuge?: string
    endereco_conjuge?: string
    numero_conjuge?: string
    complemento_conjuge?: string
    bairro_conjuge?: string
    uf_conjuge?: string
    cidade_conjuge?: string
}

interface Terceiro {
    nome: string
    cpf: string
    telefone: string
    tipo_relacionamento: string
    compra_prod_receita: boolean
}

interface Procurador {
    nome: string
    cpf: string
    telefone?: string
    rg?: string
    sexo?: string
    data_nascimento?: string
    nacionalidade?: string
    nome_social?: string
    nome_mae?: string
    nome_pai?: string
    grau_parentesco?: string
    cep?: string
    endereco?: string
    numero?: string
    complemento?: string
    bairro?: string
    cidade?: string
    uf?: string
}

interface InfoDadosCadastraisProps {
    resposta: InfoDadosCadastraisResposta
}

export interface InfoDadosCadastraisResposta {
    nome_publico: string
    nome_social: string
    rg?: string
    cpf?: string
    documento?: string
    sexo?: string
    nome_mae?: string
    nome_pai?: string
    data_nascimento: string
    nacionalidade: string
    possui_conjuge: string
    cep: string
    endereco: string
    numero: string | null
    complemento?: string
    bairro: string
    uf: string
    cidade: string
    data_adimissao?: string
    registro_estadual_produtor?: string
    inscricao_estadual?: string
    convenio?: Convenio
    inscricao_fazenda?: string
    vencimento_inscricao?: string
    aliquota_inss: number
    aliquota_senar: number
    possui_sociedade: string
    possui_procurador: string
    fazendas: Fazenda[]
    valor_aprovado?: string
    regime_casamento?: string
    tipo_relacionamento?: string
    nome_conjuge?: string
    nome_social_conjuge?: string
    rg_conjuge?: string
    cpf_conjuge?: string
    telefone_conjuge?: string
    sexo_conjuge?: string
    nome_mae_conjuge?: string
    nome_pai_conjuge?: string
    data_nascimento_conjuge?: string
    nacionalidade_conjuge?: string
    cep_conjuge?: string
    endereco_conjuge?: string
    numero_conjuge?: string
    bairro_conjuge?: string
    uf_conjuge?: string
    cidade_conjuge?: string
    sociedades?: Sociedade[]
    terceiros?: Terceiro[]
    procuradores?: Procurador[]
    possui_terceiros?: string
    procurador_nome?: string
    procurador_nome_social?: string
    procurador_rg?: string
    procurador_cpf?: string
    procurador_sexo?: string
    procurador_data_nascimento?: string
    procurador_nacionalidade?: string
}